import { IAttendance } from "@grassrootly/api/entities";
import { provider } from "../../providers";

export interface UpdatePlayerGameStatsPayload {
  gameId: number;
  playerId: number;
  goals: number;
  assists: number;
  ownGoals?: number;
  errors?: number;
  yellowCards?: number;
  redCards?: number;
  saves?: number;
}

export const UpdatePlayerGameStats = async (params: UpdatePlayerGameStatsPayload): Promise<IAttendance> =>
  provider.Request("/games/player/stats", params);
